<template>
  <div>
    <div v-for="(type,index) in types" :key="index" class="circle" style="cursor:pointer" @click="redirectPage(type)">
      <img :src="type.logo" alt="子按钮图标">
      <p>{{ type.title }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    types: {
      type: Array,
      default: null
    }
  },
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {
    redirectPage (type) {
      window.open(type.url)
    }
  }
}
</script>
<style scoped>
.circle{
  margin-left: 15px;
    width: 90px;
    height: 90px;
    background-image: url("../../../static/images/buttonstyle3.png")
  }
  .circle img{
    margin:15px auto 0;
  }
  .circle p {
    margin: 0 auto;
    font-size: 14px;
    color: #ffffff;
    font-weight: 800;
  }
</style>
